import React from 'react';
import { Type } from 'lucide-react';
import Marquee from '../ui/Marquee';

interface MarqueePreviewerProps {
    content: string;
    direction?: 'Up' | 'Down' | 'Left' | 'Right';
    scrollAmount?: number;
}

const MarqueePreviewer: React.FC<MarqueePreviewerProps> = ({ 
    content, 
    direction = 'Left',
    scrollAmount = 5
}) => {
    // If no content, show placeholder
    if (!content) {
        return (
            <div className="w-full h-full flex flex-col items-center justify-center gap-1 text-gray-500">
                <Type className="h-6 w-6" />
                <span className="text-xs">Marquee Placeholder</span>
            </div>
        );
    }

    // Map uppercase direction values from the component config to lowercase values expected by the Marquee component
    const marqueeDirection: 'left' | 'right' | 'up' | 'down' = 
        direction === 'Up' ? 'up' :
        direction === 'Down' ? 'down' :
        direction === 'Right' ? 'right' :
        'left';

    return (
        <Marquee 
            direction={marqueeDirection} 
            speed={scrollAmount}
        >
            <div dangerouslySetInnerHTML={{ __html: content }} />
        </Marquee>
    );
};

export default MarqueePreviewer;
